import {connectRouter} from 'connected-react-router';
import {History} from 'history';
import {combineReducers} from 'redux';

import {expectedPanels} from '../state/expectedPanels/reducer';
import globalReducer from '../state/global/reducer';
import interactState from '../state/interactState/reducer';
import media from '../state/media/reducer';
import polling from '../state/polling/reducer';
import reports from '../state/reports/reducer';
import runs from '../state/runs-low/reducer';
import {runSelectorRuns} from '../state/runSelectorRuns/reducer';
import sweeps from '../state/sweeps/reducer';
import viewer from '../state/viewer/reducer';
import views from '../state/views/reducer';
import workspaces from '../state/workspaces/reducer';
import auth from './auth';
import location from './location';
import report from './report';

export default (history: History) =>
  combineReducers({
    auth,
    global: globalReducer,
    media,
    location,
    router: connectRouter(history),
    report,
    views,
    interactState,
    expectedPanels,
    workspaces,
    runs, // more specifically, for runs-low (i.e. non-bucketed charts)
    runSelectorRuns,
    polling,
    reports,
    sweeps,
    viewer,
  });
